import { render, staticRenderFns } from "./ActionHeader.vue?vue&type=template&id=2edbdb32&scoped=true&"
import script from "./ActionHeader.vue?vue&type=script&lang=js&"
export * from "./ActionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbdb32",
  null
  
)

export default component.exports